/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Images
 */
import { BinIcon } from '../../../../../images/icons/Bin/Bin'
import { PlusIcon } from '../../../../../images/icons/Plus/Plus'
import { symbol } from '../../../../common/CurrencyFormat'

/**
 *     Import
 *     - CSS
 */
import '../../styles/Step03.css'

const REGEXP = '^(?!(?:^[-+]?[0.]+(?:[Ee]|$)))(?!(?:^-))(?:(?:[+-]?)(?=[0123456789.])' +
    '(?:(?:(?:[0123456789]+)(?:(?:[.])(?:[0123456789]*))?|(?:(?:[.])(?:[0123456789]+))))' +
    '(?:(?:[Ee])(?:(?:[+-]?)(?:[0123456789]+))|))$'

/**
 * TableContent class
 *
 * @class TableContent
 * @extends {React.Component<any, any>}
 */
class TableContent extends React.Component<any, any> {

    /**
     * Creates an instance of TableContent.
     *
     * @param {*} props
     * @memberof TableContent
     */
    constructor(props: any) {
        super(props)

        this.state = {
            tableItems: props.tableItems,
            updateParentStateItems: props.updateParentStateItems,
        }

    }

    /**
     * If there are new props from the father,
     * would update its current state with the new data
     *
     * @param {*} nextProps
     * @memberof TableContent
     */
    componentWillReceiveProps(nextProps: any) {
        this.setState({
            tableItems: nextProps.tableItems,
        })
    }

    handleDynamicValueChange = (index) => (event) => {
        const tableItems = this.state.tableItems
        const item = tableItems[index]
        if (index !== -1 && item) {
            if (event.target.name === 'text') {
                item.text = event.target.value
                // item.type = event.target.value
                this._updateStateItem(tableItems)
            } else if (event.target.name === 'valueInsured') {
                if (event.target.value !== '') {
                    item.valueInsured = event.target.value.replace(/^-*/, '').replace(/^0+/, '')
                    if (item.valueInsured === '') {
                        item.valueInsured = '0'
                    }
                    item.valueInsured = parseFloat(item.valueInsured)
                    this._updateStateItem(tableItems)
                } else {
                    item.valueInsured = '0'
                    this._updateStateItem(tableItems)
                }
            }
        }
    }

    handleDynamicRemove = (index) => {
        const tableItems = this.state.tableItems
        let item = tableItems.filter((e, idx) => idx !== index)
        this.state.updateParentStateItems(item)
        this.setState({ tableItems: item })
    }

    /**
     * It creates all the elements to show in the table
     *
     * @memberof TableContent
     */
    _createTableContent = () => {
        return this.state.tableItems.map((item, indx) => {
            let val = item.valueInsured === 0 ? '' : item.valueInsured
            return (
                <div className="table__content" key={item.type + indx}>
                    <div className="table__60-item">
                        <div className="input full">
                            <input
                                name="text"
                                placeholder="description"
                                type="text"
                                onChange={this.handleDynamicValueChange(indx)}
                                value={item.text}
                            />
                        </div>
                    </div>

                    <div className="table__30-item">
                        <div className="input">
                            <div className="input__pound">
                                {symbol()}
                            </div>
                            <input
                                type="number"
                                name="valueInsured"
                                className="dealer_input"
                                onChange={this.handleDynamicValueChange(indx)}
                                value={val}
                                placeholder="0"
                                step="any"
                                min="0"
                                pattern={REGEXP}
                            />
                        </div>
                    </div>

                    <div className="table__10-item">
                        <button
                            type="button"
                            onClick={() => this.handleDynamicRemove(indx)}
                            className="quote__form__dynamic--remove"
                        >
                            <BinIcon color={'#fca61b'} />
                        </button>
                    </div>
                </div>
            )
        })
    }

    /**
     * Calculates the corresponding Selling/Cost and sum insured columns
     *
     * @param {*} event the event to trigger
     * @param {*} item the item to update
     * @memberof TableContent
     */
    _calculateValue = (event, item) => {
        if (event.target.value !== '') {
            item.valueInsured = (parseFloat(item.valueInsured)).toFixed(2)
            this._updateStateItem(item)
        } else {
            item.valueInsured = Number(0)
            this._updateStateItem(item)
        }
    }

    handleDynamicAdd = () => {
        const tableItems = this.state.tableItems
        const newItem = { text: '', type: '', valueInsured: 0 }
        tableItems.push(newItem)
        this.setState({ tableItems })
    }

    /**
     * Updates a new item from the tableItems
     * in the state of the component
     *
     * @param {*} itemToUpdate
     * @memberof TableContent
     */
    // _updateStateItem(itemToUpdate: any) {
    //     let provItems = this.state.tableItems
    //     this.state.tableItems.map((item, index) => {
    //         if (this.state.tableItems[index].type === itemToUpdate.type) {
    //             provItems[index] = itemToUpdate
    //         }
    //     })

    //     this.state.updateParentStateItems(provItems)
    //     this.setState({ tableItems: provItems })
    // }

    _updateStateItem(tableItems: any[]) {
        this.state.updateParentStateItems(tableItems)
        this.setState({ tableItems })
    }

    render() {
        return (
            <div>
                <div className="table__titles shadow">
                    <div className="table__50-item">
                        Name of specified item
                    </div>
                    <div className="table__10-item">
                        {/* Total items */}
                    </div>
                    <div className="table__30-item">
                        Item value
                    </div>
                </div>
                {this._createTableContent()}
                <div className="exhibitbtn">
                    <button
                        type="button"
                        onClick={() => this.handleDynamicAdd()}
                        className="quote__form__dynamic--add"
                    >
                        <span className="addbtntext"><PlusIcon /></span> Add new item
                    </button>
                </div>
            </div>
        )
    }
}

export default TableContent



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step03m/components/TableContent.tsx